import { render, staticRenderFns } from "./environments_block.vue?vue&type=template&id=171153b7&"
import script from "./environments_block.vue?vue&type=script&lang=js&"
export * from "./environments_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "environments_block.vue"
export default component.exports